import { render, staticRenderFns } from "./rulecopy.vue?vue&type=template&id=35f184cd"
import script from "./rulecopy.vue?vue&type=script&lang=js"
export * from "./rulecopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports